export default __webpack_public_path__ + "static/media/dribbble-circle.497b224b.svg";